"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*@ngInject*/
exports.default = ['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('shop', {
            url: '/shop/:id?',
            params: { id: null },
            template: require('../views/shop.html'),
            controller: 'ShopController',
            controllerAs: 'shop',
            resolve: {
                category: ['$stateParams', 'api', function ($stateParams, api) {
                        if ($stateParams.id) {
                            return api.get('/b2b/categories/' + $stateParams.id)
                                .then(function (item) {
                                return item;
                            }, function (err) {
                                console.log(err);
                            });
                        }
                        else {
                            return null;
                        }
                    }],
                breadcrumbs: ['$stateParams', 'api', function ($stateParams, api) {
                        if ($stateParams.id) {
                            return api.get('/b2b/categories/' + $stateParams.id + '/breadcrumbs')
                                .then(function (item) {
                                return item;
                            }, function (err) {
                                console.log(err);
                            });
                        }
                        else {
                            return [];
                        }
                    }],
                products: ['$stateParams', 'api', function ($stateParams, api) {
                        if ($stateParams.id) {
                            return api.get('/b2b/categories/' + $stateParams.id + '/products')
                                .then(function (items) {
                                return items;
                            }, function (err) {
                                console.log(err);
                            });
                        }
                        else {
                            return [];
                        }
                    }],
                manufacturers: ['$stateParams', 'api', function ($stateParams, api) {
                        if ($stateParams.id) {
                            return api.get('/b2b/categories/' + $stateParams.id + '/manufacturers')
                                .then(function (items) {
                                return items;
                            }, function (err) {
                                console.log(err);
                            });
                        }
                        else {
                            return [];
                        }
                    }],
                filters: ['$stateParams', 'api', function ($stateParams, api) {
                        if ($stateParams.id) {
                            return api.get('/b2b/categories/' + $stateParams.id + '/attributes/important')
                                .then(function (items) {
                                return items;
                            }, function (err) {
                                console.log(err);
                            });
                        }
                        else {
                            return [];
                        }
                    }]
            }
        });
    }];



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/shop/config/routes.js
// module id = 360
// module chunks = 0